import { render, staticRenderFns } from "./Veronika.vue?vue&type=template&id=38c3171f&scoped=true"
import script from "./Veronika.vue?vue&type=script&lang=js"
export * from "./Veronika.vue?vue&type=script&lang=js"
import style0 from "./Veronika.vue?vue&type=style&index=0&id=38c3171f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c3171f",
  null
  
)

export default component.exports